import { SVGProps } from 'react'

const Yearn = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 32 32"
    fill="none"
    {...props}
  >
    <circle cx={16} cy={16} r={16} fill="black" className="text-neutral-900" />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="m9.327 6.283-1.26 1.282 3.073 3.13 3.072 3.13V19.65h3.58v-5.826l3.064-3.122 3.065-3.121-1.267-1.29-1.267-1.29-2.676 2.72c-1.472 1.495-2.69 2.719-2.708 2.719-.018 0-1.239-1.224-2.713-2.72A425.88 425.88 0 0 0 10.598 5c-.007 0-.579.577-1.271 1.283ZM7.907 13.8a9.186 9.186 0 0 0-.782 2.503 9.34 9.34 0 0 0 1.856 7.271c.266.34 1.046 1.134 1.377 1.402a8.871 8.871 0 0 0 5.088 2.003 8.657 8.657 0 0 0 3.393-.453c3.23-1.096 5.562-3.924 6.066-7.358a9.493 9.493 0 0 0-.3-4.038c-.154-.518-.467-1.294-.63-1.565l-.063-.104-1.362 1.386c-1.099 1.119-1.359 1.399-1.345 1.449.113.4.172.817.188 1.313.031.961-.118 1.738-.49 2.55-.722 1.578-2.131 2.703-3.854 3.08-.3.065-.41.072-1.062.071-.641 0-.767-.01-1.047-.07-1.708-.377-3.052-1.441-3.81-3.02-.343-.712-.498-1.372-.521-2.217-.017-.61.016-.98.13-1.46l.074-.31-1.357-1.382a74.808 74.808 0 0 0-1.376-1.383c-.01 0-.088.149-.172.332Z"
      className="text-neutral-0"
      clipRule="evenodd"
    />
  </svg>
)

export default Yearn
